export type CatalogAccent = "green" | "blue" | "violet";
export type CatalogExit = "none" | "fade" | "up";

export const accentToken = (accent: CatalogAccent = "green"): string =>
  ({ green: "var(--brand,#71f5a7)", blue: "var(--accent,#61a8ff)", violet: "var(--accent-2,#c5a3ff)" })[accent];

export const csv = (value: string | string[] | undefined, fallback: string[]): string[] => {
  const values = Array.isArray(value) ? value : value?.split(",");
  const clean = values?.map((item) => String(item).trim()).filter(Boolean) ?? [];
  return clean.length ? clean : fallback;
};

export const finiteDuration = (value: number | undefined, fallback: number): number =>
  Number.isFinite(value) ? Math.max(0.001, Number(value)) : fallback;

